import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import deleteIcon from '../../images/delete_icon.svg';

const DeleteNoticeIcon = (props) => {
  const { index, noticeArray, setNoticeArray } = props;
  return (
    <Avatar
      src={deleteIcon} alt='削除' sx={{ height: '24px', width: '24px', marginRight: '0', marginLeft: 'auto' }}
      onClick={() => {
        const copied = structuredClone(noticeArray);
        copied.splice(index, 1);
        setNoticeArray(copied);
      }}
    />
  );
};

export default DeleteNoticeIcon;

DeleteNoticeIcon.propTypes = {
  index: PropTypes.number,
  noticeArray: PropTypes.array,
  setNoticeArray: PropTypes.func,
};
